<template>
    <div class="apprentice-simple-card issuing-wizard">
        <design-2021-apprentice-multistep-form-wizard-component
            ref="multiStepTestIssuingForm"
            :steps="steps"
            @validateStep="validateStep"
            @submit-form="onOk">
            <template #step-1>
                <design-2021-test-center-issuing-wizard-tests-overview-component
                    v-model="settings.test"
                    :tests-in="testsIn">
                </design-2021-test-center-issuing-wizard-tests-overview-component>
            </template>

            <template #step-2>
                <design-2021-test-center-issuing-wizard-settings-component v-model="settings.groups">
                </design-2021-test-center-issuing-wizard-settings-component>
            </template>

            <template #step-3>
                <design-2021-test-center-issuing-wizard-overview-component
                    :form-data="settings"
                    :steps="steps">
                </design-2021-test-center-issuing-wizard-overview-component>
            </template>
        </design-2021-apprentice-multistep-form-wizard-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-test-center-issuing-wizard-component',
    props: {
        testsIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            steps: [
                {
                    step_number: 1,
                    title: 'Kies test',
                },
                {
                    step_number: 2,
                    title: 'Toewijzen',
                },
                {
                    step_number: 3,
                    title: 'Overzicht',
                },
            ],
            settings: {
                test: {},
                groups: {
                    students: [],
                    las_groups: [],
                    main_groups: [],
                },
            },
        };
    },

    methods: {
        onOk() {
            if (this.settings.groups.students.length > 0) {
                let data = {
                    test_id: this.settings.test.id,
                    student_ids: this.settings.groups.students.map((student) => student.id),
                };

                this.axios.post(this.routes.issueTestToStudents(), data).then(
                    (response) => {
                        this.alert
                            .multipleChoice(
                                this.$t('testcenter.test_issued_title'),
                                this.$t('testcenter.test_issued_body'),
                                {
                                    cancel: {
                                        text: this.$t('testcenter.test_issued_cancel'),
                                        value: false,
                                        closeModal: true,
                                        visible: true,
                                        className: 'btn btn-outline-primary',
                                    },

                                    confirm: {
                                        text: this.$t('testcenter.test_issued_confirm'),
                                        value: true,
                                        visible: true,
                                        closeModal: close,
                                        className: 'btn btn-primary',
                                    },
                                },
                                'success',
                            )
                            .then((confirm) => {
                                if (!confirm) {
                                    window.location.href = this.routes.testCenterTeacher();
                                    return;
                                }

                                window.location.href = this.routes.testIssuings();
                            });
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else if (this.settings.groups.main_groups.length > 0 || this.settings.groups.las_groups.length > 0) {
                let data = {
                    test_id: this.settings.test.id,
                };

                if (this.settings.groups.las_groups.length > 0) {
                    data.las_group_ids = this.settings.groups.las_groups.map((group) => group.id);
                }

                if (this.settings.groups.main_groups.length > 0) {
                    data.las_main_group_ids = this.settings.groups.main_groups.map((mainGroup) => mainGroup.id);
                }

                this.axios.post(this.routes.issueTestLas(), data).then(
                    (response) => {
                        this.alert
                            .multipleChoice(
                                this.$t('testcenter.test_issued_title'),
                                this.$t('testcenter.test_issued_body'),
                                {
                                    cancel: {
                                        text: this.$t('testcenter.test_issued_cancel'),
                                        value: false,
                                        closeModal: true,
                                        visible: true,
                                        className: 'btn btn-outline-primary',
                                    },

                                    confirm: {
                                        text: this.$t('testcenter.test_issued_confirm'),
                                        value: true,
                                        visible: true,
                                        closeModal: close,
                                        className: 'btn btn-primary',
                                    },
                                },
                                'success',
                            )
                            .then((confirm) => {
                                if (!confirm) {
                                    window.location.href = this.routes.testCenterTeacher();
                                    return;
                                }

                                window.location.href = this.routes.testIssuings();
                            });
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },

        validateStep() {},
    },

    watch: {
        'settings.test': {
            handler: function (newValue) {
                this.settings.test = newValue;
                this.settings.groups = {
                    students: [],
                    las_groups: [],
                    main_groups: [],
                };
            },
        },
    },
};
</script>

<style scoped lang="scss"></style>
